/**
 * @file TemplateIssues.tsx
 * @description Замечания к шаблону страницы товара в структуре (phase19.16
 * Р2а; uiux-design-r2a §6; SB34): `checkProductTemplate` из shared по
 * сохранённым блокам — тот же расчёт, что у сервера при публикации.
 * Ошибка мешает публикации, предупреждение (второй H1) — нет. Значок и
 * текст, не только цвет.
 */

import { AlertCircle, TriangleAlert } from "lucide-react";
import { useMemo } from "react";

import type { SitePageBlock } from "../../../lib/api-site-pages";
import { templateIssues } from "../../../lib/site-builder/template-rules";

export function TemplateIssues({ blocks }: { blocks: readonly SitePageBlock[] }) {
  const issues = useMemo(() => templateIssues(blocks), [blocks]);
  if (issues.length === 0) return null;
  return (
    <ul className="flex flex-col gap-1 rounded-lg bg-surface-low p-2" aria-label="Замечания к шаблону">
      {issues.map((issue, i) => {
        const Icon = issue.level === "error" ? AlertCircle : TriangleAlert;
        return (
          <li key={`${issue.code}:${issue.elementId ?? i}`} className="type-caption flex items-start gap-2 text-on-surface">
            <Icon aria-hidden className={issue.level === "error" ? "mt-0.5 size-4 shrink-0 text-destructive" : "mt-0.5 size-4 shrink-0 text-warning"} />
            <span>
              <span className="sr-only">{issue.level === "error" ? "Мешает публикации: " : "Предупреждение: "}</span>
              {issue.message}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
